import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Play, Pause } from "lucide-react";
import { useState, useRef } from "react";

export const AudioDemoSection = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const audioRef = useRef<HTMLAudioElement>(null);

  const togglePlay = () => {
    if (audioRef.current) {
      if (isPlaying) {
        audioRef.current.pause();
      } else {
        audioRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  const handleAudioEnded = () => {
    setIsPlaying(false);
  };

  return (
    <section className="py-20 px-4 bg-gray-100">
      <div className="container mx-auto">
        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center py-8">
            {/* Left Column - AI Native Speech Image */}
            <div className="flex items-center justify-center">
              <div className="relative">
                <img 
                  src="/lovable-uploads/079f8915-d405-4a24-b53a-e01c2606b94a.png"
                  alt="Native Speech AI-Stimmen"
                  className="w-[28rem] h-80 object-cover shadow-2xl"
                />
              </div>
            </div>

            {/* Right Column - Text and Audio Player */}
            <div className="space-y-8">
              <div>
                <h3 className="text-2xl font-bold mb-6 text-gray-900">
                  Native Speech-Stimmen anhören
                </h3>
                <p className="text-gray-600 leading-relaxed text-lg">
                  Erleben Sie die Qualität unserer KI-Stimmen live und überzeugen Sie sich selbst.
                </p>
              </div>

              {/* Audio Player */}
              <div className="bg-white rounded-2xl p-6 border border-gray-200 shadow-lg">
                <div className="flex items-center space-x-4">
                  <Button
                    onClick={togglePlay}
                    size="lg"
                    className="w-16 h-16 rounded-full bg-gray-900 hover:bg-gray-800 flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-300"
                  >
                  {isPlaying ? (
                    <Pause className="h-6 w-6 text-white" />
                  ) : (
                    <Play className="h-6 w-6 text-white ml-1" />
                  )}
                  </Button>
                  
                  <div className="flex-1">
                    <div className="text-sm font-semibold text-gray-900 mb-1">
                      Neuste Native AI-Stimmen anhören
                    </div>
                    <div className="text-xs text-gray-600 mb-2">
                      Diverse AI Stimmen in 3 Minuten
                    </div>
                    
                    {/* Progress bar placeholder */}
                    <div className="w-full bg-gray-200 rounded-full h-2">
                      <div className="bg-gray-900 h-2 rounded-full w-0 transition-all duration-300"></div>
                    </div>
                  </div>
                  
                  <div className="text-xs text-gray-500 min-w-0">
                    0:00 / 2:15
                  </div>
                </div>
                      
                      {/* Audio element (hidden) */}
                      <audio
                        ref={audioRef}
                        onEnded={handleAudioEnded}
                        className="hidden"
                      >
                        {/* Placeholder - replace with actual audio file */}
                        <source src="/audio/demo.mp3" type="audio/mpeg" />
                        Ihr Browser unterstützt das Audio-Element nicht.
                      </audio>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};